
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solution-contents/alsps/[slug]",
      function () {
        return require("private-next-pages/solution-contents/alsps/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solution-contents/alsps/[slug]"])
      });
    }
  